import { useState, useRef, useEffect } from "react"
import "./FormInput.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash, faChevronDown } from "@fortawesome/free-solid-svg-icons"

const FormInput = (props) => {
  const [focused, setFocused] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  const { disabled, label, errorMessage, onChange, id, icon, ...inputProps } = props
  const [type, setType] = useState(inputProps.type || "text")
  const [showPassword, setShowPassword] = useState(false)

  const isTypePassword = inputProps?.type === "password"
  const isTypeSelect = inputProps?.type === "select"

  delete inputProps?.type

  const togglePassword = () => {
    if (isTypePassword) {
      const next = !showPassword
      setShowPassword(next)
      setType(next ? "text" : "password")
    }
  }

  const handleBlur = () => setFocused(true)

  useEffect(() => {
    if (!dropdownOpen) return
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handler)
    return () => document.removeEventListener("mousedown", handler)
  }, [dropdownOpen])

  if (isTypeSelect) {
    const selectedOption = inputProps.options?.find((o) => o.value === inputProps.value)

    return (
      <div className="form-field" ref={dropdownRef}>
        <div
          className={`input-container${dropdownOpen ? " input-container--active" : ""}`}
          onClick={() => !disabled && setDropdownOpen((o) => !o)}
          style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        >
          <FontAwesomeIcon
            icon={icon}
            style={{
              position: "absolute",
              top: "50%",
              left: "12px",
              transform: "translateY(-50%)",
              color: "rgba(255,255,255,0.35)",
              fontSize: "1rem",
              pointerEvents: "none",
            }}
          />
          <span className={`custom-select__value${!selectedOption ? " custom-select__placeholder" : ""}`}>
            {selectedOption?.label || inputProps.placeholder}
          </span>
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`custom-select__arrow${dropdownOpen ? " custom-select__arrow--open" : ""}`}
          />

          {dropdownOpen && (
            <div className="custom-select__dropdown">
              {inputProps.options?.map((option) => (
                <div
                  key={option.value}
                  className={`custom-select__option${option.value === inputProps.value ? " custom-select__option--active" : ""}`}
                  onMouseDown={(e) => {
                    e.preventDefault()
                    onChange({ target: { name: inputProps.name, value: option.value } })
                    setDropdownOpen(false)
                    setFocused(true)
                  }}
                >
                  {option.label}
                </div>
              ))}
            </div>
          )}
        </div>
        <span className="form-field__error">{errorMessage}</span>
      </div>
    )
  }

  return (
    <div className="form-field">
      <div className="input-container">
        <FontAwesomeIcon
          icon={icon}
          style={{
            position: "absolute",
            top: "50%",
            left: "12px",
            transform: "translateY(-50%)",
            color: "rgba(255,255,255,0.35)",
            fontSize: "1rem",
            pointerEvents: "none",
          }}
        />

        <>
          <input
            {...inputProps}
            autoFocus={inputProps.autofocus}
            type={type}
            label={label}
            onChange={onChange}
            onBlur={handleBlur}
            onFocus={() => inputProps.name === "confirmPassword" && setFocused(true)}
            focused={focused.toString()}
            disabled={!!disabled}
          />
          {isTypePassword && (
            <div className="password__icon" onClick={togglePassword}>
              {!showPassword
                ? <FontAwesomeIcon icon={faEye} />
                : <FontAwesomeIcon icon={faEyeSlash} />}
            </div>
          )}
        </>
      </div>

      <span className="form-field__error">{errorMessage}</span>
    </div>
  )
}

export default FormInput
